import { DateSchema } from ".."

export const date = () => new DateSchema()
